
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class FarPayResponseModel extends Model<FarPayResponseModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'error', type: 'string', languageString: 'farPayResponse.property.error' },
		{ name: 'customers', type: 'FarPayCustomerModel[]', languageString: 'farPayResponse.property.customers', isHidden: true, isArray: true, isObject: true, new: () => { return new FarPayCustomerModel }, properties: () => { return FarPayCustomerModel.classProperties } }
	];
	[key: string]: any;
	
	public error: string;
	public customers: FarPayCustomerModel[];
    
	constructor(){
		super();
		this.error = '';
		this.customers = [];
		
	}
	getProperties(){
		return FarPayResponseModel.classProperties;
	}
}
export class FarPayCustomerModel extends Model<FarPayCustomerModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', languageString: 'farPayCustomer.property.id', isHidden: true },
		{ name: 'brandId', type: 'guid', languageString: 'farPayCustomer.property.brandId' },
		{ name: 'customerNumber', type: 'string', languageString: 'farPayCustomer.property.customerNumber' },
		{ name: 'name', type: 'string', languageString: 'farPayCustomer.property.name' },
		{ name: 'email', type: 'string', languageString: 'farPayCustomer.property.email' },
		{ name: 'phoneNumber', type: 'string', languageString: 'farPayCustomer.property.phoneNumber' },
		{ name: 'agreement', type: 'FarPayAgreementModel', languageString: 'farPayCustomer.property.agreement', isHidden: true, isObject: true, new: () => { return new FarPayAgreementModel }, properties: () => { return FarPayAgreementModel.classProperties } }
	];
	[key: string]: any;
	
	public id: number;
	public brandId?: string;
	public customerNumber: string;
	public name: string;
	public email: string;
	public phoneNumber: string;
	public agreement?: FarPayAgreementModel;
    
	constructor(){
		super();
		this.id = 0;
		this.brandId = undefined;
		this.customerNumber = '';
		this.name = '';
		this.email = '';
		this.phoneNumber = '';
		this.agreement = undefined;
		
	}
	getProperties(){
		return FarPayCustomerModel.classProperties;
	}
}
export class FarPayAgreementModel extends Model<FarPayAgreementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', languageString: 'farPayAgreement.property.id', isHidden: true },
		{ name: 'status', type: 'string', languageString: 'farPayAgreement.property.status' },
		{ name: 'type', type: 'string', languageString: 'farPayAgreement.property.type' },
		{ name: 'startDate', type: 'Date', languageString: 'farPayAgreement.property.startDate' },
		{ name: 'endDate', type: 'Date', languageString: 'farPayAgreement.property.endDate' },
		{ name: 'details', type: 'string', languageString: 'farPayAgreement.property.details' }
	];
	[key: string]: any;
	
	public id: number;
	public status: string;
	public type: string;
	public startDate?: Date;
	public endDate?: Date;
	public details: string;
    
	constructor(){
		super();
		this.id = 0;
		this.status = '';
		this.type = '';
		this.startDate = undefined;
		this.endDate = undefined;
		this.details = '';
		
	}
	getProperties(){
		return FarPayAgreementModel.classProperties;
	}
}
export class FarPayInvoiceModel extends Model<FarPayInvoiceModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', languageString: 'farPayInvoice.property.id', isHidden: true },
		{ name: 'invoiceNumber', type: 'string', languageString: 'farPayInvoice.property.invoiceNumber' }
	];
	[key: string]: any;
	
	public id: number;
	public invoiceNumber: string;
    
	constructor(){
		super();
		this.id = 0;
		this.invoiceNumber = '';
		
	}
	getProperties(){
		return FarPayInvoiceModel.classProperties;
	}
}

